module.exports = __webpack_public_path__ + "static/media/menu.7d67bc3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/menu.jpg
// module id = 724
// module chunks = 0